<script setup>
import Tour0 from "../img/tour/carousel-001.jpeg";
import Tour1 from "../img/tour/carousel-002.jpeg";
import Tour2 from "../img/tour/carousel-003.jpeg";
import Tour3 from "../img/tour/carousel-004.jpeg";
import Tour4 from "../img/tour/carousel-005.jpeg";
import Tour5 from "../img/tour/carousel-006.jpeg";

const tours = [Tour0, Tour1, Tour2, Tour3, Tour4, Tour5]
</script>

<template>
  <div>
    <el-carousel>
      <el-carousel-item v-for="tour in tours">
        <div class="flex flex-vertical fit">
          <div class="flex image">
            <el-image :src="tour" fit="fit" :preview-src-list="tours"/>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<style lang="scss" scoped>
.el-carousel {
  width: 100%;
  height: 605px;
  border-radius: 12px;
}

::v-deep(.el-carousel__container) {
  height: 605px;
  width: 100%;
}
</style>
